export enum UserEmailType {
  PERSONAL = "PERSONAL",
  WORK = "WORK",
  OTHER = "OTHER",
}

export enum UserPhoneType {
  MOBILE = "MOBILE",
  OFFICE = "OFFICE",
  OTHER = "OTHER",
}

export enum UserAddressType {
  HOME = "HOME",
  WORK = "WORK",
  OTHER = "OTHER",
}

export type EmailItem = {
  id: string;
  userId?: string;
  label: "Work" | "Personal" | "Other";
  email: string;
  type?: string;
  verifiedAt?: string | null;
  isPrimary?: boolean;
  token?: string | null;
  tokenValidity?: string | null;
  verifyEmail?: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export type PhoneItem = {
  id: string;
  userId?: string;
  label: "Mobile" | "Office" | "Other";
  phone: string;
  countryCode?: string;
  phoneNumber?: string;
  verifyNumber?: string;
  type?: string;
  verifiedAt?: string | null;
  isPrimary?: boolean;
  token?: string | null;
  tokenValidity?: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export type AddressItem = {
  id: string;
  label: "Home" | "Work" | "Other";
  addressLine1: string;
  address?: string;
  city: string;
  state: string;
  country?: string;
  zip: string;
  zipCode?: string;
  type?: string;
  isPrimary?: boolean;
};

export type ProfileData = {
  id: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string | null;
  gender?: string;
  profilePicture?: string | null;
  streetAddress?: string;
  city?: string;
  state?: string;
  country?: string;
  zipCode?: string;
};

export type ContactProfileResponse = {
  status: boolean;
  data: {
    progress: number;
    isVerified: string | null;
    emailList: Array<{
      id: string;
      userId: string;
      email: string;
      type: string;
      verifiedAt: string | null;
      isPrimary: boolean;
      token: string | null;
      tokenValidity: string | null;
      verifyEmail: string | null;
      createdAt: string;
      updatedAt: string;
    }>;
    phoneList: Array<{
      id: string;
      userId: string;
      countryCode: string;
      phoneNumber: string;
      type: string;
      verifiedAt: string | null;
      isPrimary: boolean;
      token: string | null;
      tokenValidity: string | null;
      createdAt: string;
      updatedAt: string;
    }>;
    profileData: {
      id: string;
      profile?: ProfileData;
      [key: string]: any;
    };
    addressList: Array<{
      id: string;
      userId: string;
      address: string;
      city: string;
      state: string;
      country: string;
      zipCode: string;
      type: string;
      isPrimary: boolean;
      createdAt: string;
      updatedAt: string;
    }>;
  };
};
